const colors = {
	white: '#FFFFFF',
	brand_05: '#f5f1f7',
	brand_10: '#ede3f3',
	brand_20: '#c688ea',
	brand_30: '#9648c2',
	brand_40: '#8235ae',
	brand_50: '#621c8a',
	brand_60: '#500d76',
	brand_70: '#390357',
	brand_80: '#290040',
	gray_05: '#f7f7f7',
	gray_10: '#ededed',
	gray_20: '#dedede',
	gray_30: '#cccccc',
	gray_40: '#b2b2b2',
	gray_60: '#707070',
	grey_65: '#795548',
	gray_70: '#545454',
	gray_80: '#3b3b3b',
	gray_90: '#292929',
	gray_95: '#1c1c1c',
	gray_100: '#121212',
	brand_secondary_05: '#f8f6ef',
	brand_secondary_10: '#eae6dc',
	brand_secondary_60: '#85754e',
	brand_secondary_70: '#70603a',
	brand_secondary_80: '#605029',
	blue_05: '#ebfcff',
	blue_10: '#c9f4ff',
	blue_60: '#007aa3',
	blue_70: '#005e7d',
	blue_80: '#064157',
	yellow_10: '#ffecc2',
	yellow_40: '#fc9d03',
	yellow_70: '#7d4705',
	yellow_80: '#54330d',
	red_05: '#fff5f2',
	red_10: '#ffe8e3',
	red_40: '#ff9580',
	red_50: '#f7644a',
	red_60: '#d4371c',
	red_70: '#a12512',
	red_80: '#6e1d13',
	red_90: '#510e06',
	red_100: '#d01884',
	red_110: '#d93025',
	green_10: '#befade',
	green_20: '#007b83',
	green_40: '#00cf64',
	green_50: '#00ab50',
	green_70: '#03612c',
	green_80: '#08421f',
	green_90: '#188038',
	disabled: '#cfd8dc',
	purple_01: '#a142f4',
	blue_01: '#1a73e8',
	yellow_01: '#f9ab00',
	onlineDot: '#22c55e',
	offlineDot: '#ef4444',
	black: '#000000',
	neutral_6: '#c4c3c5',
	neutral: '#666367'
};

export default colors;
